export const getSubscriptionData = async (subscriptionId)=>{
  try {
    const response = await fetch('/api/getSubscriptionInfo.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ subscriptionId })
    });

    const data = await response.json();
    if (!response.ok) {
      return { data: null, error: data.error || 'Unknown server error' };
    }

    return { data, error: null };
  } catch (error) {
    return { data: null, error: error.message || 'Fetch failed' };
  }
}